import React from "react";
import Oneimg from '../assets/cbu/01.jpeg'
import One2 from '../assets/cbu/14.jpeg'
import "../css/Testimonial.scss";
// import { Height } from "@mui/icons-material";


function Testimonial() {
	const whatsapp = () => {
        const whatsappUrl = `https://wa.me/+6281770710004`;
        window.open(whatsappUrl, '_blank', 'noopener noreferrer');
      };

	
  return (

<section class="light bg-white mt-4" id="testimonial">
	<div class="container">
		<article class="postcard light blue">
			<img class="postcard__img" src={Oneimg} loading="eager" alt='alternative_text_of_your_image' />
			<div class="postcard__text t-dark">
				<h1 class="postcard__title blue">Jabodetabek </h1>
				<div class="postcard__bar"></div>
				<div class="postcard__preview-txt">Anda bisa langsung memesan jasa sewa Hiace kami untuk keperluan penjemputan, acara keluarga, acara kantor, futsal, silahturahmi antar keluarga yang mungkin sudah lama belum terwujud dengan alasan tidak ada kendaaran, izinkan kami melayani anda dengan setulus hati, amanah dan berkah buat semuanya</div>
				<ul class="postcard__tagbox">
					<li class="tag__item"><i class="fas fa-tag mr-2"></i>Praktis</li>
					<li class="tag__item"><i class="fas fa-clock mr-2"></i>Aman</li>
					<li onClick={whatsapp} class="tag__item play blue fw-bolder text-white" >
						<i class="fas fa-play mr-2" ></i>Pesan Sekarang
					</li>
				</ul>
			</div>
		</article>
		<article class="postcard light yellow">
			<img class="postcard__img" src={One2} loading="eager" alt="nice"/>
			<div class="postcard__text t-dark">
				<h1 class="postcard__title yellow">Jawa, Bali dan Sumatra</h1>
				<div class="postcard__bar"></div>
				<div class="postcard__preview-txt">Perjalanan lintas provinsi akan terasa nyaman bila di temani dengan perangkat Karaoke, anda bersama keluarga, rekan, teman bisa bernyanyi, bersenandung lagu lagu populer dalam perjalanan</div>
				<ul class="postcard__tagbox">
					<li class="tag__item"><i class="fas fa-tag mr-2"></i>Murah</li>
					<li class="tag__item"><i class="fas fa-clock mr-2"></i>Nyaman</li>
					<li onClick={whatsapp} class="tag__item play yellow fw-bolder text-white">
						<i class="fas fa-play mr-2" ></i>Pesan Sekarang
					</li>
				</ul>
			</div>
		</article>
	</div>
</section>
  );
}

export default Testimonial;